(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bon-category-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.bon-groups__arrow');
    if (!button) return;

    const section = button.closest('.bon-groups');
    const track = section?.querySelector('[data-bon-track]');
    if (!track) return;

    const firstCard = track.querySelector('.bon-groups__card');
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = (firstCard?.getBoundingClientRect().width || track.clientWidth) + gap;
    const direction = button.dataset.direction === 'previous' ? -1 : 1;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-category-tiles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.brand-category-tiles__arrow');
    if (!button) return;

    const section = button.closest('.brand-category-tiles');
    const track = section?.querySelector('[data-brand-category-track]');
    if (!track) return;

    const firstCard = track.querySelector('.brand-category-tiles__card');
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = (firstCard?.getBoundingClientRect().width || track.clientWidth) + gap;
    const direction = button.dataset.direction === 'previous' ? -1 : 1;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hultafors-category-carousel"] && !Shopify.designMode) return;
  try {
    
  const getCarouselMetrics = (track) => {
    const firstCard = track.querySelector('.hultafors-groups__card');
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = (firstCard?.getBoundingClientRect().width || track.clientWidth) + gap;
    return { distance };
  };

  const syncCarouselDots = (section) => {
    const track = section.querySelector('[data-hultafors-track]');
    const dots = section.querySelectorAll('.hultafors-groups__dot');
    if (!track || !dots.length) return;

    const { distance } = getCarouselMetrics(track);
    const activeIndex = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / distance)));

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const initializeCategoryCarousel = (section) => {
    if (!section || section.dataset.carouselInitialized === 'true') return;

    const track = section.querySelector('[data-hultafors-track]');
    if (!track) return;

    section.dataset.carouselInitialized = 'true';
    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => syncCarouselDots(section));
    }, { passive: true });
    syncCarouselDots(section);
  };

  document.querySelectorAll('.hultafors-groups').forEach(initializeCategoryCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    initializeCategoryCarousel(event.target.querySelector('.hultafors-groups'));
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.hultafors-groups__arrow');
    const dot = event.target.closest('.hultafors-groups__dot');
    if (!arrow && !dot) return;

    const section = event.target.closest('.hultafors-groups');
    const track = section?.querySelector('[data-hultafors-track]');
    if (!track) return;

    const { distance } = getCarouselMetrics(track);

    if (dot) {
      track.scrollTo({ left: distance * Number(dot.dataset.index || 0), behavior: 'smooth' });
      return;
    }

    const direction = arrow.dataset.direction === 'previous' ? -1 : 1;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
